module.exports = __webpack_public_path__ + "static/media/imagenet6.ba3be719.png";